import { render, staticRenderFns } from "./wxorder.vue?vue&type=template&id=2dcc76f4&scoped=true&"
import script from "./wxorder.vue?vue&type=script&lang=js&"
export * from "./wxorder.vue?vue&type=script&lang=js&"
import style0 from "./wxorder.vue?vue&type=style&index=0&id=2dcc76f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc76f4",
  null
  
)

export default component.exports